/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Not_StartedInputs */

const vi_shop_home_not_started = /** @type {(inputs: Shop_Home_Not_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chưa tới lịch`)
};

/**

* @param {Shop_Home_Not_StartedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_not_started = /** @type {((inputs?: Shop_Home_Not_StartedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Not_StartedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_not_started(inputs)
});